import { Layout, Row } from 'antd';
import { SaveAndExitHeader } from 'components/header';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { push } from 'connected-react-router';
import { PatientRoutes } from 'routes';

import './questionnaire-completion.scss';

import {
  BaseButton,
  QuestionnaireGreyButton
} from 'components/button/button-base';
import PeoplePaddle from 'img/people-paddleboard.svg';
import { getPatientLinkUrl } from 'navigation/router/route-switch/route-switch-patient/utils/patient-route-helpers';
import { Link, useParams } from 'react-router-dom';
import { TakeABreakFilter } from '../assessment-controller/_components/take-a-break-filter';

const config = {
  defaultDescription: `You're on your way! If you feel like you need a break, please do so. You have enough time to come back and finish later.`,
  defaultImage: PeoplePaddle
};

export interface CompletionProps {
  /* title?: string; */
  description?: string;
  img?: string;
  /**
   * Take break callback
   */
  takeBreakCb?: () => void;
  /**
   * Continue callback
   */
  continueCb?: () => void;
}

/**
 * This component renders after the Promis questionnaire is complete
 */
export function QuestionnaireCompletionPromis(props: CompletionProps) {
  const { patientId } = useParams<{ patientId: string }>();
  const dispatch = useDispatch();
  // const location = useLocation();
  // console.log(location.state);
  const [showBreak, setBreak] = useState(false);
  const continueLink = getPatientLinkUrl(
    PatientRoutes.AssessmentControlFlow,
    patientId
  );
  function handleOnContinue() {
    dispatch(push(continueLink));
  }
  function takeBreak() {
    setBreak(prev => !prev);
  }
  return (
    <>
      {showBreak && <TakeABreakFilter onContinue={handleOnContinue} />}

      <Layout className="layout-container">
        <SaveAndExitHeader
          title={'Function Questionnaire: Completed'}
          label={'Save & Exit'}
          onExit={() => dispatch(push('/'))}
        />

        <Row>
          <div
            style={{
              display: 'flex',
              flex: '1',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              marginLeft: '120px'
            }}
          >
            {/* <ConnectedOutcomeMeasuresProgressBar label size={['100%', 18]} /> */}
            <div style={{ maxWidth: '600px', marginBottom: '60px' }}>
              <p className="completion-title">Great job!</p>
              <p className="completion-description">
                {props.description ?? config.defaultDescription}
              </p>
            </div>
            <div>
              <div style={{ paddingBottom: '24px' }}>
                <QuestionnaireGreyButton
                  // minHeight={60}
                  // minWidth={150}
                  // label={'I need a break'}
                  // rounded={true}
                  // baseFont={true}
                  // iconBefore={false}
                  icon={null}
                  onClick={takeBreak}
                  style={{ fontSize: 20 }}
                >
                  I need a break
                </QuestionnaireGreyButton>
              </div>
              <BaseButton style={{ fontSize: 20 }}>
                <Link to={continueLink}>Continue to next questionnaire</Link>
              </BaseButton>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flex: '1',
              flexDirection: 'column',
              maxHeight: '100dvh'
            }}
          >
            <img
              src={props.img ?? config.defaultImage}
              className="completion-img"
            />
          </div>
        </Row>
      </Layout>
    </>
  );
}
